import ApiService from '@/services/apiService';
import { mapState, mapGetters } from 'vuex';
import clone from 'lodash/clone';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'ViewHome',
  data: function () {
    return {
      pwValue: '',
      favorites: [],
      tileSizeSetting: parseInt(this.$store.state.app.tileSize) || 0,
      defaultTileSize: {
        sm: 6,
        dm: 4,
        lg: 3,
        xl: 2
      },
      bigTileSize: {
        sm: 12,
        dm: 6,
        lg: 4,
        xl: 3
      },
      firstSteps: [{
        title: this.$i18n_t('Common.home.firstStep1'),
        text: this.$i18n_t('Common.home.firstStepHint1'),
        image: './img/firstSteps/star.svg',
        link1: '/fm-add-ticket',
        link2: '/fm-add-ticket',
        link3: '/fm-add-ticket'
      }, {
        title: this.$i18n_t('Common.home.firstStep2'),
        text: this.$i18n_t('Common.home.firstStepHint2'),
        image: './img/firstSteps/settings.svg',
        link1: '/fm-add-ticket',
        link2: '/fm-add-ticket',
        link3: '/fm-add-ticket'
      }, {
        title: this.$i18n_t('Common.home.firstStep3'),
        text: this.$i18n_t('Common.home.firstStepHint3'),
        image: './img/firstSteps/team.svg',
        link1: '/fm-add-ticket',
        link2: '/fm-add-ticket',
        link3: '/fm-add-ticket'
      }],
      announcement: null,
      dialog: false,
      showFirstSteps: false,
      dialogNo: 0,
      componentKey: 1
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions', 'announcements']),
    ...mapGetters({
      sessionUserId: 'authentication/userId',
      sessionUser: 'authentication/user',
      tenantId: 'authentication/tenantId'
    }),
    canCreateTickets() {
      return this.permissions['IsFmTicket.create'] || this.permissions['IsFmTicket.manage'];
    },
    hasAdminRights() {
      return this.permissions['all.manage'];
    },
    tileSize() {
      if (this.tileSizeSetting === 0) {
        return this.defaultTileSize;
      }
      if (this.tileSizeSetting === 1) {
        return this.bigTileSize;
      }
      return this.defaultTileSize;
    },
    shouldDisplayAnnouncement() {
      if (!this.announcements.length || !this.announcements[0].active || this.announcements[0].presentationType !== 'message') {
        return false;
      }
      const now = new Date();
      const startDate = new Date(this.announcements[0].start);
      const endDate = new Date(this.announcements[0].end);
      return (this.announcements[0].start === null || startDate <= now) && (this.announcements[0].end === null || endDate >= now);
    }
  },
  mounted() {
    this.getFavorites();
  },
  methods: {
    openDialog(i) {
      this.dialog = true;
      this.dialogNo = i;
    },
    getFavorites() {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      ApiService.fetchFavoritesByUserId(this.sessionUserId).then(favorites => {
        if (this.canCreateTickets && favorites.length) {
          favorites.splice(0, 0, {
            type: 'createTicket'
          });
        }
        this.favorites = favorites;
        if (!this.favorites.length) {
          this.showFirstSteps = true;
        }
      }).catch(error => {
        console.error('Error while loading favorites.', error);
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    removeFavorite(itemId) {
      this.favorites = this.favorites.filter(f => f.id !== itemId);
      this.favorites = clone(this.favorites);
    },
    closeAlert() {
      const announcementId = get(this.$store.state.app, 'announcements[0].id');
      const userAnnouncements = get(this.sessionUser, 'properties.announcements', []);
      this.announcement = this.announcements[0];
      this.$store.state.app.announcements = this.$store.state.app.announcements.slice(1);
      if (announcementId) {
        set(this.sessionUser, 'properties.announcements', userAnnouncements.filter(a => parseInt(a) !== parseInt(announcementId)));
        this.updateUser(this.sessionUser);
      }
    },
    updateUser(userData) {
      return ApiService.updateUser(userData).then(() => {
        this.updateAnnouncementState(this.announcement);
      }).catch(error => {
        console.error(error);
      });
    },
    updateAnnouncementState(announcement) {
      return ApiService.tenantUpdateSystemAnnouncementState(this.tenantId, announcement);
    },
    sizeUp() {
      this.tileSizeSetting = 1;
      this.$store.commit('app/setTileSize', 1);
      this.componentKey += 1;
    },
    sizeDown() {
      this.tileSizeSetting = 0;
      this.$store.commit('app/setTileSize', 1);
      this.componentKey += 1;
    },
    pushToRouter(path, selected = null) {
      this.$router.push({
        path: path,
        query: {
          parent: selected ? selected.id : null,
          openTree: JSON.stringify(this.open)
        }
      });
    }
  }
};